<template>
    <div style="margin-bottom: 10vh;">
        <ul style="list-style: none; margin: 10px 0">
            <li>
                <div>
                    <h3>
                        <a href="https://www.hackerrank.com/">Hackerrank, Bangalore</a>
                    </h3>
                    <hr />
                    <h4>
                        <b>Senior Software Engineer (Apr,2022-Present)</b>
                    </h4>
                    <h4>
                        <b>Software Development Engineer 2
                            (September,2021-Mar,2022)</b>
                    </h4>
                    <ul>
                        <li>
                            <strong>HackerRank Engage</strong>
                            <ul>
                                <li>
                                    Designed and built the backend architecture
                                    for HackerRank Engage Platform from scratch.
                                </li>
                                <li>
                                    Built features by aligning them with
                                    business requirements.
                                </li>
                                <li>
                                    Provided substantial input in product
                                    development and design from the consumers'
                                    point of view.
                                </li>
                                <li>
                                    Ensured rapid delivery of features to meet
                                    the product's go-to-market (GTM) plan.
                                </li>
                                <li>
                                    Guided juniors to maintain code quality and
                                    reliability of the new product.
                                </li>
                                <li>
                                    Led the development on Node.js-based Nestjs
                                    framework, defining best practices for the
                                    team.
                                </li>
                                <li>
                                    Worked with DevOps to set up production and
                                    development infrastructure for the product.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>MySQL 8 Upgrade/Migration</strong>
                            <ul>
                                <li>
                                    Led the upgrade/migration of the HackerRank
                                    Monolith from MySQL 5.7 to 8.
                                </li>
                                <li>
                                    Devised a migration plan involving multiple
                                    applications and RDS instances.
                                </li>
                                <li>
                                    Planned downtime for the migration window
                                    and conducted impact analysis and avoidance.
                                </li>
                                <li>
                                    Coordinated with multiple resource owners to
                                    analyze the impact.
                                </li>
                                <li>
                                    Created and executed a phase-wise migration
                                    plan for lower and production environments.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Candidate Prep Portal</strong>
                            <ul>
                                <li>
                                    Designed and built a new application
                                    extending the existing system.
                                </li>
                                <li>
                                    Delivered a market-fit product within a
                                    quarter.
                                </li>
                                <li>
                                    Provided input for overall product
                                    development from a candidate's point of
                                    view.
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Others</strong>
                            <ul>
                                <li>
                                    Created and maintained an ETL pipeline using
                                    Airflow.
                                </li>
                                <li>
                                    Conducted proof of concepts (POCs) on EDA
                                    using Kafka and logging using Newrelic.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="https://www.softwareag.com/">SoftwareAG, Bangalore</a>
                    </h3>
                    <hr />
                    <h4>
                        <b>Software Engineer 1 (June,2020-September,2021)</b>
                    </h4>
                    <h4><b>R&D Intern (January,2020-June,2020)</b></h4>
                    <ul>
                        <li>Writing B2B Cloud API's using Spring</li>
                        <li>
                            Building and deploying Images using Docker and
                            Kubernetes
                        </li>
                        <li>
                            Worked on Multi-pod support, EDR Capabilities,
                            Runtime Configuration Support
                        </li>
                        <li>
                            Adding and Modifying features on server-side of
                            CloudStreams
                        </li>
                        <li>
                            R&D on OpenAPI 3.0, Batch Monitoring, Adobe
                            Experience Platform
                        </li>
                    </ul>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="https://www.gradeup.co/">GradeUp, Noida</a>
                    </h3>
                    <hr />
                    <h4><b>Backend Intern (June,2019-September,19)</b></h4>
                    <ul>
                        <li>API Development on Node.js for Ed-Tech product</li>
                        <li>
                            Used GraphQL to modernize the existing code base
                        </li>
                        <li>Worked on ElasticSearch, Python, Go</li>
                        <li>Agile Software Development Approach</li>
                    </ul>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="https://www.lecupido.com/">Cupido (Startup), Bangalore</a>
                    </h3>
                    <hr />
                    <h4><b>Backend Intern (April,2019-May,19)</b></h4>
                    <ul>
                        <li>
                            Building API’s on Node.js for E-Commerce Product
                        </li>
                        <li>Converting business logic to code</li>
                        <li>Deployment to AWS EC2</li>
                    </ul>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="http://www.zester.in">Zester (Startup), Noida</a>
                    </h3>
                    <hr />
                    <h4>
                        <b>Rest Api development on Node.js
                            (June,2018-December,18)</b>
                    </h4>
                    <ul>
                        <li>
                            Building API’s on Node.js for web and mobile apps
                            for Social Networking platform
                        </li>
                        <li>Solving day to day bugs on the live website</li>
                        <li>Agile Software Development Approach</li>
                    </ul>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="http://www.hopaka.com">Hopaka Technologies (Startup), Noida</a>
                    </h3>
                    <hr />
                    <h4>
                        <b>Android App Development (Feb,2018-April,2018)</b>
                    </h4>
                    <p>
                        Developed an android app to solve parking problems in
                        cities.
                    </p>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="https://www.eninov.com">Eninov Systems, Noida</a>
                    </h3>
                    <hr />
                    <h4>
                        <b>Hybrid App Development (June,2017-August,2017)</b>
                    </h4>
                    <p>
                        Worked on an accounting app based on phonegap for the
                        organisation.
                    </p>
                </div>
            </li>
            <li>
                <div>
                    <h3>
                        <a href="http://www.expertsinstitute.co.in/">Experts' Institute, Allahabad</a>
                    </h3>
                    <hr />
                    <h4><b>Java Teaching (April,2016-June,2016)</b></h4>
                    <p>Teaching core java to class 9th-10th students</p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Experience",
};
</script>



// WEBPACK FOOTER //
// src/components/experienceComponent.vue